<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'collectBillEdit',
    components: {
      baseEdit,
    },
  };
</script>
